import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { getTotalPrice } from "../../HotelComponent/HotelListingCard/components/Price/getPriceUtils.js";
const HotelPricePin = (props)=>{
    const price = props?.hotel?.ratesSummary?.grandTotal ? getTotalPrice({
        totalPrice: props?.hotel?.ratesSummary?.grandTotal,
        priceDisplayRegulation: props?.hotel?.ratesSummary?.priceDisplayRegulation,
        grandTotalExcludingTax: props?.hotel?.ratesSummary?.grandTotalExcludingTax
    }) : props?.hotel?.ratesSummary?.minPrice;
    const cost = Number(price);
    const currency = props?.hotel?.ratesSummary?.minCurrencyCodeSymbol || '$';
    return /*#__PURE__*/ jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ jsx("div", {
                className: "bg-primary-8 border-primary-1 rounded-full border px-2 py-1",
                children: /*#__PURE__*/ jsxs("span", {
                    className: "text-priceRetail-1 font-bold",
                    children: [
                        currency,
                        Math.floor(cost)
                    ]
                })
            }),
            /*#__PURE__*/ jsx("div", {
                className: "bg-primary-8 border-primary-1 absolute bottom-0 left-1/2 h-2 w-2 -translate-x-1/2 translate-y-[3.5px] rotate-45 border-b border-r"
            })
        ]
    });
};
export { HotelPricePin };
